import React from 'react';
import './cardStyles.css';
//props : { answer, score, isShown }
export const Card = (props) =>{
    const isShown = props.isShown ? "showCard" : "hideCard";
    return (
        <div className="card">
        <p className = {isShown}> {props.answer}</p>
        <p className = {isShown}> {props.score}</p>
        </div>
    )
}